import store from "../../../store";
import menu_mem_count from './mem_count';

jQuery('#js-nav-menu .mem_count_menu').each(function() {
    new Vue({
        store,
        name : "MEMCOUNT",
        el:this,
        data () {
            return {

            }
        },
        created () {

        },
        components : {
            menu_mem_count
        }
    });
});
